const buildDonationForm = () => {
	const countryIdInput = document.querySelector('.js-countryId-input');
	//let scrollTimeoutId = undefined;

	const fetchCountries = (onSuccess) => {
		const request = new XMLHttpRequest();
	    request.open('GET', '/umbraco/api/Countries/Get', true);

	    request.onload = () => {
	        if (request.status >= 200 && request.status < 400) {
	            return onSuccess(JSON.parse(request.responseText));
	        }
	    }

	    request.send();
	}

	const initButtons = () => {		
		const stOneOffButton = document.getElementById("st-oneoff-payment-button");
		const gcRegularButton = document.getElementById("gc-regular-payment-button");

		const form = document.querySelector('.js-donation-form');
		const fieldset = form.querySelector('fieldset');
		const spinner = document.querySelector('.donation__spinner');

		const submitForm = () => {
			validateForm(form, (data) => {
				//fieldset.setAttribute('disabled', true);

				/*processForm(data, () => {
					fieldset.removeAttribute('disabled');
				}, () => {
					fieldset.removeAttribute('disabled');
				});*/
				spinner.style.display = 'block';
				form.submit();
			})
		}

		stOneOffButton.addEventListener('click', (e) => {
			e.preventDefault();
			submitForm();
		});
		gcRegularButton.addEventListener('click', (e) => {
			e.preventDefault();
			submitForm();
		});
	}

	const updateButtons = () => {
		const stOneOffButton = document.getElementById("st-oneoff-payment-button");
		const gcRegularButton = document.getElementById("gc-regular-payment-button");

		if (window.donationIsOneOff) {
			stOneOffButton.style.display = 'block';
			gcRegularButton.style.display = 'none';
		} else {
			stOneOffButton.style.display = 'none';
			gcRegularButton.style.display = 'block';
        }
	}
	
	const focusOnEl = (el) => {
		let focusTarget;

		if (el.tagName === 'INPUT' || el.tagName === 'SELECT') {
			focusTarget = el;
		} else {
			const button = el.querySelector('button');

			if (button) {
				focusTarget = button;
			}
		}

		if (focusTarget) {
			focusTarget.focus();
		}

		const scrollPosition = window.pageYOffset + el.getBoundingClientRect().top;
		
		const elements = [
			document.querySelector('.navigation-bar-holder'),
			document.querySelector('.condition-sub-nav')
		];

		let elHeight = 0;

		elements.forEach(el => {
			if (el) {
				elHeight += el.clientHeight;
			}
		});

		const topHeight = scrollPosition - (elHeight + 30);
		
		window.scroll(0, topHeight);
	}

	const validateForm = (form, onSuccess) => {
		const data = new FormData(form);
		const errorsContainer = form.querySelector('.js-donation-form-errors');
		let requiredFields = [];

		errorsContainer.innerHTML = null;

		for (let entry of data) {
			if (entry[0].indexOf('donation-') !== 0) {
				const input = form.querySelector('#contact-' + entry[0]);
				if (input == null) {
					continue;
				}
				//console.log(entry);
				const field = input.parentNode;
				const errorEl = field.querySelector('.js-donation-form-input-error');

				input.setAttribute('aria-invalid', false);
				field.classList.remove('field--error');

				if (errorEl) {
					errorEl.innerHTML = null;
				}

				if (input.getAttribute('aria-required') === 'true' && (input.value === '' || input.value === '-1')) {
					requiredFields.push({
						input: input,
						type: 'required'
					});
					input.setAttribute('aria-invalid', true);
				} else {
					if (input.type === 'email' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value)) {
						requiredFields.push({
							input: input,
							type: 'invalid'
						});
						input.setAttribute('aria-invalid', true);
					}
					if (input.type === 'select') {
						//console.log('select');
					}
				}
			}
		}

		if (requiredFields.length > 0) {
			let listHtml = '';
			let isDonationReasonError = false;

			requiredFields.forEach(item => {
				const field = item.input.parentNode;
				const label = field.querySelector('label')
				const errorEl = field.querySelector('.js-donation-form-input-error');

				field.classList.add('field--error');

				if (label) {
					listHtml += `<li class='js-donation-form-error' data-input='${item.input.id}'><button type="button">${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}</button></li>`
				}

				if (errorEl) {
					errorEl.innerHTML = `${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}`
				}

				if (item.input.id === 'contact-in-memory-of' || item.input.id === 'contact-collection-reason') {
					isDonationReasonError = true;
				}
			});

			let html = `<p>Please fix the following errors before submitting.</p>`;

			if (listHtml !== '') {
				html += `<ul>${listHtml}</ul>`;
			}

			errorsContainer.innerHTML = html;


			if (isDonationReasonError) {
				focusOnEl(document.querySelector('#donation-step-2'))
			} else {
				focusOnEl(errorsContainer);
			}			

			form.querySelectorAll('.js-donation-form-error').forEach(error => {
				error.addEventListener('click', () => {
					const input = form.querySelector('#' + error.dataset.input);

					if (input) {
						input.focus();
						focusOnEl(input);
					}
				});
			});
		} else {
			onSuccess(data)
		}
	}

	const populateCountries = (countries) => {
		let options = '';
				
		countries.forEach(option => {
			const selected = option.name === 'United Kingdom' ? 'selected=selected' : '';
			options += `<option value='${option.countryId}' ${selected}>${option.name}</option>`;
		})

		if (countryIdInput && options !== '') {
			countryIdInput.innerHTML = options;
		}
	}

	const getDonationFrequency = () => {
		const donationFrequency = document.querySelectorAll('[name="donation-frequency"]');

		let donationFrequencyValue;

		donationFrequency.forEach(input => {
			if (input.checked) {
				donationFrequencyValue = input.value;
			}
		});

		return donationFrequencyValue;
	}

	const watchForm = () => {
		const form = document.querySelector('.js-donation-form');
		const fieldset = form.querySelector('fieldset');

		if (form) {
			const donationFrequency = document.querySelectorAll('[name="donation-frequency"]');
			const donationAmount = document.querySelectorAll('[name="donation-amount"]');
			const donationAmountCustom = document.querySelector('[name="donation-amount-custom"]');
            const donationAmountCustomRadio = document.querySelector('[id="donation-amount-custom-radio"]');
            const donationReason = document.querySelectorAll('[name="donation-reason"]');            

			//fieldset.removeAttribute('disabled');

			donationReason.forEach(input => {
				input.addEventListener('change', () => {
					const subFields = form.querySelectorAll('[data-required-when^="donation-reason="]');

					subFields.forEach(subField => {
						const subInput = subField.querySelector('input, select, textarea');
						let required = subField.dataset.requiredWhen.split('=');

						if (required[1] === input.value) {
							subField.parentNode.classList.remove('is-d-none');
							subField.classList.add('field--required');

							if (subInput) {
								//subInput.value = subInput.tagName === 'SELECT' ? -1 : null;
								subInput.setAttribute('aria-required', true);
							}
						} else {
							subField.parentNode.classList.add('is-d-none');
							subField.classList.remove('field--required');
							subField.classList.remove('field--error');

							const errorEl = subField.querySelector('.js-donation-form-input-error');
							const errorLink = form.querySelector(`.js-donation-form-error[data-input="${subInput.id}"]`);

							if (subInput) {
								//subInput.value = subInput.tagName === 'SELECT' ? -1 : null;
								subInput.setAttribute('aria-required', false);
							}

							if (errorEl) {
								errorEl.innerHTML = '';
							}

							if (errorLink) {
								errorLink.parentNode.removeChild(errorLink);
							}
						}
					});
				});
			});

			const oneOffAmounts = document.querySelectorAll('.donation-amount-one-off');
			const regularAmounts = document.querySelectorAll('.donation-amount-regular');

			donationFrequency.forEach(frequencyInput => {
				frequencyInput.addEventListener('change', () => {
					if (donationAmountCustom.value !== '') {
						setNote(donationAmountCustom.dataset[`note${frequencyInput.value}`])
						setvalue(donationAmountCustom.value, true);
					} else {
						donationAmount.forEach(input => {
							//if (input.checked) {
							//	setNote(input.dataset[`note`])
							//	setvalue(input.value, false);
							//}
							input.checked = false;
							setNote('')
							setvalue(0, false);
						});
					}

                    if (frequencyInput.value == 'OneOff') {
						window.donationIsOneOff = true;

						regularAmounts.forEach((e) => {
							e.classList.add('is-d-none');
						})
						oneOffAmounts.forEach((e) => {
							e.classList.remove('is-d-none');
						})

                    } else {
						window.donationIsOneOff = false;

						oneOffAmounts.forEach((e) => {
							e.classList.add('is-d-none');
						})
						regularAmounts.forEach((e) => {
							e.classList.remove('is-d-none');
						})
                    }
					
					updateButtons();
				});
			});

			donationAmount.forEach(input => {
				if (input.checked) {
					setNote(input.dataset[`note`])
					setvalue(input.value, false);
				}
				input.addEventListener('change', () => {					
					setNote(input.dataset[`note`])
                    setvalue(input.value, false);
                    donationAmountCustom.value = '';
				});
			});

			donationAmountCustom.addEventListener('input', () => {

				setNote(donationAmountCustom.dataset[`note${getDonationFrequency()}`])
				setvalue(donationAmountCustom.value, true);

				if (donationAmountCustom.value === '' || donationAmountCustom.value === '0' || !isDecimal(donationAmountCustom.value)) {
					donationAmountCustom.value = '';

					let amount = null;
					if (window.donationIsOneOff) {
						amount = oneOffAmounts[0];
					} else {
						amount = regularAmounts[0];
					}

					//Restore to first fixed amount if nothing is checked
					//let input = donationAmount[0];

					//donationAmount.forEach(currentInput => {
					//	if (currentInput.id != donationAmountCustomRadio.id && currentInput.checked) {
					//		input = currentInput;
					//	}
					//});

					const input = amount.querySelector('input');
					input.checked = true;
					setNote(input.dataset[`note`])
					setvalue(input.value, false);
				}
                else {
                    donationAmountCustomRadio.checked = true;
                }
            });
		}
	}

	const isDecimal = (string) => {
		return /^\d*\.?\d*$/.test(string);
	}

	const setNote = (note) => {
		const el = document.querySelector('.js-donation-note');

		if (el) {
			el.innerHTML = note || el.dataset.default;
		}
	}

	const setvalue = (value, isCustomAmount) => {
		// Round number to two decimal points
		value = parseFloat(value).toFixed(2);

		window.donationAmount = value;

		const el = document.querySelector('.js-donation-value');
		const nextSteps = document.querySelector('.js-donation-next-steps');

		if (nextSteps) {
			if (value && nextSteps.classList.contains('is-d-none')) {
				nextSteps.classList.remove('is-d-none');
			} else if (!value && !nextSteps.classList.contains('is-d-none')) {
				nextSteps.classList.add('is-d-none');
			}
		}

		if (el) {
			if (value == 0) {
				el.innerHTML = el.dataset.default;
			} else {
				el.innerHTML = value ? `You are donating <span>&pound;${value}</span>` : el.dataset.default;
			}
		}

		if (!isCustomAmount && value > 0) {
			const step2 = document.querySelector('#donation-step-2');
			const yOffset = -220;
			const y = step2.getBoundingClientRect().top + window.pageYOffset + yOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
		}
					
		setGiftAidAmounts(value);
		updateButtons();		
	}

	const setGiftAidAmounts = (value) => {
		const oldAmount = document.querySelector('.gift-aid-dynamic-oldamt');
		const newAmount = document.querySelector('.gift-aid-dynamic-newamt');

		value = parseFloat(value);

		if (value <= 0) {
			oldAmount.innerHTML = "1.00";
			newAmount.innerHTML = "1.25";
		} else {
			const rounded = Math.floor(value);
			oldAmount.innerHTML = value.toFixed(2);
			newAmount.innerHTML = (value + (rounded * 0.25)).toFixed(2);
		}
	}

	const init = () => {
		initButtons();
		if (countryIdInput) {
			fetchCountries(countries => {
				populateCountries(countries);
				watchForm();
			})
		} else {
			watchForm();
		}
	}

	init();
}

const theForm = document.querySelector('.js-donation-form')

if (theForm) {
	buildDonationForm()
}